export const CHAT_LOGIN_SUCCESS = 'chatLoginSuccess'
export const LOGIN_SUCCESS = 'loginSuccess'
export const LOGIN_FAILURE = 'loginFailure'
export const LOGOUT_SUCCESS = 'logoutSuccess'
export const LOGOUT_FAILURE = 'logoutFailure'
